import { useEffect, useRef } from "react";
import { IconType } from "react-icons";
import styled from "styled-components";
import { useFilters } from "core/features/filters/store";

export type ItemProps = {
    id: string,
    nome: string,
    enabled: boolean,
    icon: IconType,
    color?: string
}

type Props = {
    onClick: (item: any) => void;
    onClose?: () => void;
    data: ItemProps[];
}

export function FiltersMapaTematicoPlanoOperacional({
    onClick,
    onClose,
    data,
}: Props) {
    const { filters } = useFilters();
    const { menuName, tabBarSessaoPlanejamentoOperacional } = filters;
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            const target = event.target as Node;
            const clickedToggleButton = (target as HTMLElement)?.closest?.(
                '[data-testid="menu-filtros-mapas-tematicos"]'
            );

            if (
                onClose &&
                containerRef.current &&
                !containerRef.current.contains(target) &&
                !clickedToggleButton
            ) {
                onClose();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);

    const name = tabBarSessaoPlanejamentoOperacional === 'relatorios' ? 'relatório' : 'mapa temático';

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            const target = event.target as Node;
            const clickedToggleButton = (target as HTMLElement)?.closest?.(
                '[data-testid="menu-filtros-mapas-tematicos"]'
            );
            if (
                onClose &&
                containerRef.current &&
                !containerRef.current.contains(target) &&
                !clickedToggleButton
            ) {
                onClose();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose]);
    return (
        <Container ref={containerRef}>
            <Title>Escolha um {name}</Title>
            {data.map(({ nome, icon: Icon }, index) => (
                <Item key={index} onClick={() => onClick(nome)} selected={menuName === nome}>
                    <ItemContent>
                        <ItemIcon>
                            <Icon size={20} />
                        </ItemIcon>
                        <ItemTitle>
                            <p>{nome}</p>
                        </ItemTitle>
                    </ItemContent>
                </Item>
            ))}
        </Container>
    )
}

const Container = styled.div`
    z-index: 1;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: var(--chakra-colors-white);
    position: absolute;
    top: 60px;
    width: 100%;
    height: auto;
    transform-origin: center top;
    transform: scaleY(1);
    transition: 0.5s;   
`;

const Title = styled.h3`
    font-weight: var(--chakra-fontWeights-bold);
    padding: 16px;
    font-size: 16px;
    color: var(--chakra-colors-gray-900);
`;

const Item = styled.div<{ selected?: boolean }>`
    display: flex;
    background: ${props => props.selected ? 'var(--chakra-colors-gray-100)' : 'transparent'} !important;
    cursor: pointer;
    transition: 0.1s linear;
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom-width: 1px;
    border-left: ${props => props.selected ? '4px solid green' : 'none'} !important;
    border-bottom-color: var(--chakra-colors-gray-100);
    border-bottom-style: solid;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    &:hover {
        background-color: var(--chakra-colors-gray-100) !important;
    }
`;

export const ItemContent = styled.div`
    display: flex;
`;

export const ItemIcon = styled.div`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 80px;
    padding-inline: 6px;

    img {
        height: 15px;
        max-width: 30px;
    }
`;

export const ItemTitle = styled.div`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;

    p {
        color: var(--chakra-colors-gray-900);
        font-size: 14px;
    }
`;